import { COLORS } from '../../constants';

const styles = theme => {
  const minSm = theme.breakpoints.up('sm');

  return {
    progressWrapper: {
      minHeight: 'calc(100vh - 210px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: COLORS.WHITE_DARK,
    },
    root: {
      backgroundColor: COLORS.WHITE_DARK,
    },
    innerWrapper: {
      margin: '0 auto',
      [minSm]: {
        padding: '40px 30px',
        display: 'flex',
        justifyContent: 'space-between',
        maxWidth: 1200,
      },
    },
    personalWrapper: {
      [minSm]: {
        width: '100%',
      },
    },
    businessWrapper: {
      [minSm]: {
        width: '68%',
      },
    },
  };
};

export default styles;
